/* global Sys, Services */
Sys.ns("Services");

/**
 * The Spin Service.
 *
 * @class Services.Spin
 * @extends Services.Base
 */
Services.Spin = {
    constructor: function() {
        Services.Spin.superclass.constructor.apply(this, arguments);
        this._isAnimating = false;
        this._isInSpiningState = false;
    },

    _setupEvents: function() {
        this.observable.on({
            "notify:stateHandler.enteringSpinningState": this._spinStarted.bind(this),
            "notify:stateHandler.leavingSpinningState": this._spinEnded.bind(this)
        });
    },

    /**
     * Gets the state of animations for spin.
     *
     * @returns {boolean} Is spin is animating.
     */
    isAnimating: function() {
        return this._isAnimating;
    },

    /**
     * Gets the state of spin.
     *
     * @returns {boolean} Is game is in spinning state.
     */
    isInSpinningState: function() {
        return this._isInSpiningState;
    },

    /**
     * Sets the status of spin animation.
     *
     * @returns {void}
     */
    setAnimationStarted: function() {
        this._isAnimating = true;
        this.publish("animationStarted");
    },

    /**
     * Sets the status of spin animation.
     *
     * @returns {void}
     */
    setAnimationEnded: function() {
        this._isAnimating = false;
        this.publish("animationEnded");
    },

    /**
     * Sets the mode of spin to stated.
     *
     * @returns {void}
     */
    _spinStarted: function() {
        this._isInSpiningState = true;
        this.publish("started");
    },

    /**
     * Sets the mode of spin to ended.
     *
     * @returns {void}
     */
    _spinEnded: function() {
        this._isInSpiningState = false;
        this.publish("ended");
    }
};

Services.Spin = Sys.extend(
    Services.Base,
    Services.Spin,
    "Services.Spin"
);
